export default __webpack_public_path__ + "static/media/image_5.66d55522.png";